export const DISCONTINUE_RULE = 'discontinue_rule';
export const SCORE_RULE = 'score_rule';
